import cliente4 from './cliente4';

const initialState = {
    clienteActivo: 'cliente4', 
    temas: [
      { code: 'cliente4', text: 'GAMA' },
    ],
    estilosDeCliente: {
      cliente4, // gamma
    },
  };

  export default initialState;